const ACTIONS = {
    CHALLENGE_LIST: "challenges",
};

export default ACTIONS;